import { render, staticRenderFns } from "./SalesForceTab.vue?vue&type=template&id=19e25a19&scoped=true&"
import script from "./SalesForceTab.vue?vue&type=script&lang=js&"
export * from "./SalesForceTab.vue?vue&type=script&lang=js&"
import style0 from "./SalesForceTab.vue?vue&type=style&index=0&id=19e25a19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e25a19",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QBtn,QInput,QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QBtn,QInput,QSelect})
